export function isAdmin(roles) {
  if (!roles) return false;
  return roles.find((r) => r.name === "admin") ? true : false;
}

export function isProductManager(roles) {
  if (!roles) return false;
  return roles.find((r) => r.name === "product_manage") ? true : false;
}

export function isProductEditor(roles) {
  if (!roles) return false;
  return roles.find((r) => r.name === "product_edit") ? true : false;
}
